import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText, isNotEmpty } from "../../../helpers/StringHelpers"
import { StreetNameValidator } from "../../../services/validation/address-employment-form/StreetNameValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const StreetNameField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
        isDisabled,
    } = props

    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(defaultValue ?? ``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
        setValue(defaultValue ?? ``)
    }, [defaultValue, errorText])

    const validateField = (value: string) => {
        const validator = new StreetNameValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const text = capitaliseText(event.target.value)
        setValue(capitaliseText(text))
        handleChange(capitaliseText(text))
    }
    const handleOnBlur = (event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
        validateField(event.target.value)
    }

    return (
        <TextField
            fullWidth
            error={isNotEmpty(errorMessage)}
            helperText={t(errorMessage)}
            id="street-name"
            label={t(`street_name`)}
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            disabled={isDisabled}
            inputProps={{ maxLength: 35 }}
        />
    )
}

export { StreetNameField }